import { createSlice } from '@reduxjs/toolkit';
import { UserState } from '@utils/types';

const initialState: UserState = {};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      state.id = action.payload.id || '';
      state.externalId = action.payload.external_id || '';
      state.fullName = action.payload.name || '';
      state.mobile = action.payload.mobile || action.payload.phoneNo;

      const segmentCode = action.payload.vendor_segment || '';
      state.segmentCode = state.segmentName = segmentCode;
      state.tier =
        (segmentCode.toLowerCase() !== 'non vpp'
          ? segmentCode.toLowerCase() || ''
          : 'non-vpp') || '';
    },
    unsetUserDetails: (state: UserState) => {
      Object.keys(state).forEach((key) => delete state[key as keyof UserState]);
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserDetails, unsetUserDetails } = userSlice.actions;

export default userSlice.reducer;
